export type PrometheusValkeyConnectedClientsStatsBackendApiProps = {
    created: number;
    connected_clients: number;
};

export default class PrometheusValkeyConnectedClientsStats {
    readonly created: number;
    readonly connectedClients: number;

    constructor(props: PrometheusValkeyConnectedClientsStatsBackendApiProps) {
        this.created = props.created;
        this.connectedClients = props.connected_clients;
    }
}
